import { FunctionComponent, useState } from "react";

interface ITextInputProps {
  id: string;
  placeholder: string;
  onChange?: (value: string) => void;
  containerStyles?: string;
  value?: string;
  password?: boolean;
}

const TextInput: FunctionComponent<ITextInputProps> = ({
  id,
  onChange,
  placeholder,
  containerStyles,
  value,
  password
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className={`relative ${containerStyles}`}>
      <input
        id={id}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        type={password ? "password" : undefined}
        className={`w-full py-2 pl-9 pr-3 rounded-md bg-white/10 text-black border transition-all duration-300 outline-none ${
          focused
            ? "border-blue-400 shadow-[0_0_10px_rgba(59,130,246,0.6)]"
            : "border-black/20"
        }`}
      />
    </div>
  );
};

export default TextInput;
